import { render } from "./Splash.vue?vue&type=template&id=56e6966d"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=56e6966d&lang=css"
script.render = render

export default script